/**
 * @generated SignedSource<<70623ee7ed26d28dc8d26bd2529b9871>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditVideoElementV2Input = {
  clientMutationId?: string | null | undefined;
  title: string;
  videoElementId: string;
  vimeoId: string;
  vimeoVideoSourceId: string;
};
export type VideoElementForm_EditVideoElementMutation$variables = {
  input: EditVideoElementV2Input;
};
export type VideoElementForm_EditVideoElementMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly editVideoElement: {
        readonly videoElement: {
          readonly " $fragmentSpreads": FragmentRefs<"VideoElementForm_VideoElementFragment">;
        };
      } | null | undefined;
    };
  };
};
export type VideoElementForm_EditVideoElementMutation = {
  response: VideoElementForm_EditVideoElementMutation$data;
  variables: VideoElementForm_EditVideoElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoElementForm_EditVideoElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditVideoElementV2Payload",
                "kind": "LinkedField",
                "name": "editVideoElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoElement",
                    "kind": "LinkedField",
                    "name": "videoElement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "VideoElementForm_VideoElementFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoElementForm_EditVideoElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditVideoElementV2Payload",
                "kind": "LinkedField",
                "name": "editVideoElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoElement",
                    "kind": "LinkedField",
                    "name": "videoElement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vimeoId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34e02edb9a3c57f29faa040507a1a0a3",
    "id": null,
    "metadata": {},
    "name": "VideoElementForm_EditVideoElementMutation",
    "operationKind": "mutation",
    "text": "mutation VideoElementForm_EditVideoElementMutation(\n  $input: EditVideoElementV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      editVideoElement(input: $input) {\n        videoElement {\n          ...VideoElementForm_VideoElementFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment VideoElementForm_VideoElementFragment on VideoElement {\n  id\n  title\n  vimeoId\n}\n"
  }
};
})();

(node as any).hash = "2b22e28c436c7a976fce95a098f26244";

export default node;
